import React from 'react';
import cx from 'classnames';
import Icon from '../Icon';

export default class AccordionItem extends React.Component {
    constructor ( props ) {
        super( props );

        this.toggleActive = this.toggleActive.bind( this );

        this.state = {
            isActive: props.isActive
        };
    }

    toggleActive () {
        this.setState( {isActive: !this.state.isActive} );
    }

    render () {
        const {label, children, className = '', headingClassName = '', activeClassName, inactiveClassName} = this.props;

        const {isActive} = this.state;
        const collapseGroupClassName = cx( className, {
            'collapse-group--active': isActive,
            [activeClassName]: isActive,
            [inactiveClassName]: !isActive
        } );

        const _headingClassName = cx(
            'flex w-full items-center cursor-pointer',
            headingClassName || 'py-3'
        );

        return (
            <div className={collapseGroupClassName}>
                <div onClick={this.toggleActive} className={_headingClassName}>
                    <Icon name="ArrowDown" width="16" className="flex-none collapse-group-icon text-grey mx-1"/>
                    <span className="inline-block ml-4 mr-2">{label}</span>
                </div>
                {this.state.isActive &&
                    <div className="hidden" data-collapse-target>
                    {children}
                </div>
                }
            </div>
        )
    }
}
